/* OBEN advertorial – vanilla JS, no libraries. */
(function () {
  'use strict';

  var root = document.querySelector('.oben-adv');
  if (!root) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var offer = root.querySelector('[data-oben-offer]');
  var form = root.querySelector('[data-oben-form]');
  var PENDING_KEY = 'obenPendingPurchase';

  /* ---------- Meta Pixel ---------- */
  var pixelId = offer ? offer.getAttribute('data-pixel-id') : '';
  if (pixelId && !window.fbq) {
    /* Standard Meta loader, only when a Pixel ID is set in the offer section. */
    !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
  }
  function track(name, params) {
    try { if (typeof window.fbq === 'function') window.fbq('track', name, params || {}); } catch (e) {}
  }
  function pkgParams(radio) {
    return {
      content_name: radio ? radio.getAttribute('data-label') : 'OBEN',
      content_type: 'product',
      value: radio ? Number(radio.getAttribute('data-price')) : 0,
      currency: 'ALL'
    };
  }

  /* ---------- Package selection ---------- */
  var radios = form ? Array.prototype.slice.call(form.querySelectorAll('.oben-card__radio')) : [];
  var summary = form ? form.querySelector('[data-oben-summary]') : null;

  function selected() {
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
    return null;
  }
  function refresh() {
    radios.forEach(function (r) { r.closest('.oben-card').classList.toggle('is-selected', r.checked); });
    var r = selected();
    if (summary && r) {
      summary.textContent = r.getAttribute('data-label') + ' · ' + formatLek(r.getAttribute('data-price'));
    }
    refreshDaily(r);
  }
  var daily = form ? form.querySelector('[data-oben-daily]') : null;
  function fillDaily(tpl, r) {
    var days = Number(r.getAttribute('data-days')) || 0;
    var price = Number(r.getAttribute('data-price')) || 0;
    return tpl.split('{daily}').join(formatLek(price / days)).split('{price}').join(formatLek(price)).split('{days}').join(String(days));
  }
  function refreshDaily(r) {
    if (!daily || !r) return;
    var ok = Number(r.getAttribute('data-days')) > 0;
    daily.hidden = !ok;
    if (!ok) return;
    var main = daily.querySelector('[data-oben-daily-main]');
    var sub = daily.querySelector('[data-oben-daily-sub]');
    if (main) main.innerHTML = fillDaily(daily.getAttribute('data-text'), r);
    if (sub) sub.textContent = fillDaily(daily.getAttribute('data-sub'), r);
    var cmp = form.querySelector('[data-oben-compare-price]');
    if (cmp) cmp.textContent = fillDaily('{daily}', r);
  }
  function formatLek(n) {
    return String(Math.round(Number(n) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' Lekë';
  }
  radios.forEach(function (r) {
    r.addEventListener('change', function () { refresh(); track('AddToCart', pkgParams(r)); });
  });
  refresh();

  if (offer) track('ViewContent', pkgParams(selected()));

  /* ---------- CTA buttons: go to #oferta with the recommended pack selected ---------- */
  function selectRecommended() {
    var rec = form && form.querySelector('.oben-card__radio[data-recommended]');
    if (rec && !rec.checked) { rec.checked = true; refresh(); }
  }
  root.querySelectorAll('[data-oben-cta]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!offer) return;
      e.preventDefault();
      selectRecommended();
      offer.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#oferta');
    });
  });
  if (location.hash === '#oferta') selectRecommended();

  /* ---------- Sticky bar: visible after the hero, hidden over the offer ---------- */
  var sticky = root.querySelector('[data-oben-sticky]');
  var hero = root.querySelector('[data-oben-hero]');
  if (sticky && hero && 'IntersectionObserver' in window) {
    var pastHero = false, offerVisible = false;
    var setSticky = function () {
      var show = pastHero && !offerVisible;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      var link = sticky.querySelector('a');
      if (link) link.tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      pastHero = !en.isIntersecting && en.boundingClientRect.top < 0;
      setSticky();
    }).observe(hero);
    if (offer) {
      new IntersectionObserver(function (entries) {
        offerVisible = entries[0].isIntersecting;
        setSticky();
      }, { rootMargin: '0px 0px -30% 0px' }).observe(offer);
    }
  }

  /* ---------- Timeline progress ---------- */
  root.querySelectorAll('[data-oben-timeline]').forEach(function (tl) {
    var steps = Array.prototype.slice.call(tl.querySelectorAll('[data-oben-step]'));
    tl.style.setProperty('--oben-tl-n', steps.length);
    if (reduceMotion) return; /* stays fully filled and static */
    tl.classList.add('is-anim');
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var horizontal = window.matchMedia('(min-width: 760px)').matches;
      var rect = tl.getBoundingClientRect();
      var p;
      if (horizontal) {
        /* Fills as the row moves from the bottom of the screen to the middle. */
        p = (vh - rect.top) / (vh * 0.5 + rect.height);
      } else {
        /* Fills as the reading line (60% of screen height) moves down the list. */
        p = (vh * 0.6 - rect.top) / rect.height;
      }
      p = Math.max(0, Math.min(1, p));
      tl.style.setProperty('--oben-tl-p', p.toFixed(3));
      steps.forEach(function (s, i) {
        var at = steps.length > 1 ? i / (steps.length - 1) : 1;
        if (!horizontal) at = (s.offsetTop + 14) / rect.height;
        s.classList.toggle('is-on', p >= at - 0.01);
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  });

  /* ---------- Video facade ---------- */
  root.querySelectorAll('[data-oben-video]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var iframe = document.createElement('iframe');
      iframe.src = btn.getAttribute('data-oben-video');
      iframe.title = btn.getAttribute('aria-label') || 'Video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      btn.innerHTML = '';
      btn.appendChild(iframe);
      btn.removeAttribute('data-oben-video');
      btn.style.cursor = 'default';
    }, { once: true });
  });

  /* ---------- Customer videos: only one plays at a time ---------- */
  var reviewVideos = Array.prototype.slice.call(root.querySelectorAll('video[data-oben-review-video]'));
  reviewVideos.forEach(function (vid) {
    vid.addEventListener('play', function () {
      reviewVideos.forEach(function (other) { if (other !== vid && !other.paused) other.pause(); });
    });
  });

  /* ---------- Order form ---------- */
  if (!form) return;
  var mode = offer.getAttribute('data-mode');
  var submit = form.querySelector('[data-oben-submit]');
  var errorEl = form.querySelector('[data-oben-error]');
  var started = false;

  form.addEventListener('focusin', function () {
    if (started) return;
    started = true;
    track('InitiateCheckout', pkgParams(selected()));
  });

  function fail() {
    if (submit) submit.disabled = false;
    if (errorEl) errorEl.hidden = false;
  }

  /* Same rule as the ITALVIT form: international digits, 355 (AL) or 383 (XK). */
  function intlPhone(raw, country) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.indexOf('00') === 0) d = d.slice(2);
    if (d.indexOf('355') === 0 || d.indexOf('383') === 0) return '+' + d;
    if (d.charAt(0) === '0') d = d.slice(1);
    return '+' + (country === 'XK' ? '383' : '355') + d;
  }

  function field(n) {
    var el = form.querySelector('[name="contact[' + n + ']"]');
    return el ? el.value.trim() : '';
  }

  form.addEventListener('submit', function (e) {
    var r = selected();
    if (!r) { e.preventDefault(); return; }
    if (errorEl) errorEl.hidden = true;

    if (mode === 'checkout') {
      /* Cart permalink: replaces the cart with this variant and opens checkout
         with the shipping address prefilled. Phone and city are also kept as
         order attributes, so they reach the order even if a checkout field is skipped. */
      e.preventDefault();
      var variant = r.getAttribute('data-variant');
      if (!variant) { fail(); return; }
      if (!started) { started = true; track('InitiateCheckout', pkgParams(r)); }
      submit.disabled = true;
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var parts = field('name').split(/\s+/);
      var first = parts.shift() || '';
      var last = parts.join(' ') || first;
      var country = offer.getAttribute('data-country') || 'AL';
      var tel = intlPhone(field('Telefoni'), country);
      if (tel.indexOf('+383') === 0) country = 'XK';
      var addr = 'checkout[shipping_address]';
      /* checkout[phone] fills the contact field ("Email ose numri i telefonit"). */
      var params = [
        [addr + '[first_name]', first],
        [addr + '[last_name]', last],
        [addr + '[address1]', field('Adresa')],
        [addr + '[city]', field('Qyteti')],
        [addr + '[country]', country],
        [addr + '[phone]', tel],
        ['checkout[phone]', tel],
        ['attributes[Telefoni]', tel],
        ['attributes[Qyteti]', field('Qyteti')],
        ['attributes[Paketa]', r.getAttribute('data-label')]
      ].map(function (p) { return encodeURIComponent(p[0]) + '=' + encodeURIComponent(p[1]); }).join('&');
      var qty = Math.max(1, parseInt(r.getAttribute('data-qty'), 10) || 1);
      window.location.href = base + 'cart/' + encodeURIComponent(variant) + ':' + qty + '?' + params;
      return;
    }

    /* "form" mode: Shopify contact form. It needs an email, so one is built from the phone. */
    var phone = form.querySelector('[data-oben-phone]');
    var digits = phone ? phone.value.replace(/\D/g, '') : '';
    var emailEl = form.querySelector('[data-oben-email]');
    var bodyEl = form.querySelector('[data-oben-body]');
    var domain = offer.getAttribute('data-email-domain') || 'example.com';
    if (emailEl) emailEl.value = 'porosi.' + digits + '@' + domain;
    if (bodyEl) {
      var get = field;
      bodyEl.value = [
        'POROSI E RE (COD)',
        'Paketa: ' + r.getAttribute('data-label'),
        'Çmimi: ' + formatLek(r.getAttribute('data-price')),
        'Emri: ' + get('name'),
        'Telefoni: ' + get('Telefoni'),
        'Qyteti: ' + get('Qyteti'),
        'Adresa: ' + get('Adresa')
      ].join('\n');
    }
    try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(pkgParams(r))); } catch (err) {}
    submit.disabled = true;
  });

  window.addEventListener('pageshow', function () { if (submit) submit.disabled = false; });

  /* After a successful contact-form post: fire Purchase once, show the thank-you box. */
  var thanks = root.querySelector('[data-oben-thanks]');
  if (thanks) {
    try {
      var pending = sessionStorage.getItem(PENDING_KEY);
      if (pending) { track('Purchase', JSON.parse(pending)); sessionStorage.removeItem(PENDING_KEY); }
    } catch (err) {}
    offer.scrollIntoView({ block: 'start' });
    thanks.focus({ preventScroll: true });
  }
})();
